import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'overTime/'

const initialState = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const setOverTime = createAsyncThunk('ot/sot', async (otData, thunkAPI) => {

    try {

        const result = await axios.post(API_URL + 'setOverTime', otData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }

})

export const menuSlice = createSlice({
    name: 'sal',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(setOverTime.pending, (state) => {
                state.isLoading = true
            })
            .addCase(setOverTime.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.salarySheet = action.payload
            })
            .addCase(setOverTime.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.salarySheet = []
            })
    }
})

export const { reset } = menuSlice.actions

export default menuSlice.reducer
